<template>
  <div class="congestion-area">
    <div class="row">
      <ImageVertical
        v-for="(item, index) in spotExList"
        :key="index"
        :img=item.img
        :text=item.text
        :selected="checkSelected(item.text)"
        @click-image="onSelect"
      />
    </div>
  </div>
</template>

<script>
import ImageVertical from '@/components/Molecules/ImageVertical'
import { SPOT_EX_LIST } from '../../const.js'

export default {
  name: 'consetn-check',
  components: {
    ImageVertical
  },
  computed: {
    spotExList () { return SPOT_EX_LIST }
  },
  props: {
    selectedSpot: { type: String }
  },
  methods: {
    onSelect (text) {
      this.$emit('select-spot', text)
    },
    loadImg (img) {
      return require(`@/assets/${img}`)
    },
    checkSelected (input) {
      return input === this.selectedSpot
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import './../../unified.scss';
.congestion-area{
  position: fixed;
  overflow: scroll;
  width: 100%;
}
.row{
  display: flex;
  justify-content: space-between;
  padding: 0.2rem 0.5rem;
}

</style>



// WEBPACK FOOTER //
// src/components/Organisms/SpotExamples.vue